import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import ReactBnbGallery from 'react-bnb-gallery';
import { FiCamera, FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import 'react-bnb-gallery/dist/style.css';
import './styles.css';

export default function Gallery({data}) {
    const [open, setOpen] = useState(false);    
    const [numberPhoto, setNumberPhoto] = useState(0);
    const [photos, setPhotos] = useState([]);
    
    const options = {
        center: true,   
        loop: true,
        margin: 1,
        responsive: {0: {items: 1}, 768: {items: 2}}
    };
    
    const carousel = React.useRef(null);

    const handleGallety = (index) => {
        setOpen(true);
        setNumberPhoto(index);
    }

    const handleLoadImagesForCarousel = (data) => {
        const images = [];
        data.forEach(img => images.push(img.imagem))
        setPhotos(images);
    }

    useEffect(()=>{
       handleLoadImagesForCarousel(data)
    },[data]);

    return (
        <div id="gallery-content">
            <button onClick={() => handleGallety(0)}>                
                <FiCamera size={20}/> &nbsp;
                <span> {photos.length} Fotos</span>
            </button>

            {photos.length > 0 ? 
            <div className="gallery">
                <OwlCarousel ref={carousel} options={options} >
                    {data.map((item, index) => (
                        <div key={index} className="item">
                            <img src={item.imagem} alt="imagem" onClick={() => handleGallety(index)}/>
                        </div>  
                    ))}                                   
                </OwlCarousel>
                <div className="carousel-nav">
                    <span onClick={() => carousel.current.prev()}><FiArrowLeft/></span>
                    <span onClick={() => carousel.current.next()}><FiArrowRight/></span>
                </div>
            </div>
            : ''}

            <ReactBnbGallery
                show={open}
                photos={photos}
                onClose={()=>setOpen(false)}
                wrap = {true}
                opacity={.9}
                activePhotoIndex={numberPhoto}
                showThumbnails={false}
            /> 
        </div>
    );
}